import { MuiThemeProvider, Typography } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { WithStyles } from 'decorators/withStyles';
import { IBackground } from 'interfaces/theme';
import * as React from 'react';
import { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';
import { CDN_URL } from 'settings';

import ColorPicker from './ColorPicker';
import ImagePicker from './ImagePicker';

interface IProps {
  classes?: any;
}

interface IState {
  model: IBackground;
}

@WithStyles(theme => ({
  recomendations: {
    fontSize: 16
  },
  removeImageButton: {
    color: '#DC3F53',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '8px 0',
    border: '2px solid #DC3F53',
    padding: '6px 20px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#c33345',
      borderColor: '#c33345'
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: theme.variables.colors['success']
      }
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp
    })
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none'
    }
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  iOSIcon: {
    width: 24,
    height: 24
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1]
  },
  imageTitle: {
    fontSize: 16
  }
}))
export default class Background extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { model: null };
  }

  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(
        rxjsOperators.logError(),
        rxjsOperators.bindComponent(this),
        rxjsOperators.map(model => model.background)
      )
      .subscribe(model => {
        this.setState({ model });
      });
  }

  onChangeBackground = (color: string) => {
    themeCustomizerService.setData({
      background: { ...this.state.model, color }
    });
  };

  onChangeUseInMobile = (event: any) => {
    themeCustomizerService.setData({
      background: { ...this.state.model, useInMobile: event.target.checked }
    });
  };

  onChangeImage = (image: string) => {
    themeCustomizerService.setData({
      background: { ...this.state.model, image }
    });

    this.setState(oldState => {
      return { ...oldState, model: { ...oldState.model, image } };
    });
  };

  showImage = (image: string) => {
    if (!image) {
      return '';
    }
    return image.startsWith('/') ? `${CDN_URL}${image}` : `${image}`;
  };

  render() {
    const { model } = this.state;
    const { classes } = this.props;

    const recomendations = {
      width: 1920,
      height: 1080
    };

    if (!model) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <ColorPicker value={model.color} label="Cor do Fundo" handleChangeColor={this.onChangeBackground} />

        <div>
          <Typography variant="subtitle1" className={classes.imageTitle} gutterBottom>
            Imagem
          </Typography>
          <ImagePicker
            recomendations={recomendations}
            onChangeImage={this.onChangeImage}
            image={this.showImage(model.image)}
          />
        </div>

        {/* <FormControlLabel
          control={
            <Switch
              classes={{
                switchBase: classes.iOSSwitchBase,
                bar: classes.iOSBar,
                icon: classes.iOSIcon,
                iconChecked: classes.iOSIconChecked,
                checked: classes.iOSChecked,
              }}
              disableRipple
              checked={model.useInMobile}
              onChange={this.onChangeUseInMobile}
              value='useINMobile'
            />
          }
          label='Usar imagem no mobile'
        /> */}

        {/* <Typography variant='body2'>Usar imagens grandes no mobile podem aumentar o peso da página.
        Recomendamos deixar desligado e usar apenas a cor</Typography> */}
      </MuiThemeProvider>
    );
  }
}
